var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      staticClass: "modal-reward",
      attrs: {
        name: _vm.modalName,
        "show-close": false,
        "cover-closeable": false,
        "close-btn-handler": _vm.handleClose
      },
      on: { modalClose: _vm.handleClose }
    },
    [
      _c(
        "div",
        {
          staticClass: "content",
          attrs: { slot: "modal-content" },
          slot: "modal-content"
        },
        [
          _c("div", { staticClass: "reward-box auto_scale" }, [
            _c("div", {
              staticClass: "reward-title",
              domProps: {
                innerHTML: _vm._s(_vm.dataAward.award_abstract || "恭喜你获得")
              }
            }),
            _vm._v(" "),
            _c("div", { ref: "reward-wrap", staticClass: "reward-wrap" }, [
              _c(
                "div",
                { staticClass: "reward-scroll" },
                _vm._l(_vm.dataAward.award_list, function(item, i) {
                  return _c("div", { key: i, staticClass: "item" }, [
                    _c("p", { staticClass: "title" }, [
                      _vm._v(_vm._s(item.name))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "des" }, [
                      _vm._v(_vm._s(item.synopsis))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "money" }, [
                      _c("span", [_vm._v("¥")]),
                      _vm._v(_vm._s(item.max_amount))
                    ])
                  ])
                }),
                0
              )
            ]),
            _vm._v(" "),
            !_vm.isWeixin
              ? _c("div", {
                  class: { "reward-btn": true, gray: _vm.isGray },
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.mainData.award_result_button_desc || "获取更多优惠"
                    )
                  },
                  on: {
                    click: function($event) {
                      return _vm.btnClickHandle(true)
                    }
                  }
                })
              : _vm.isWeixinMini === "weixinmini"
              ? _c("div")
              : _c("div", { staticClass: "btn-in-weixin" }),
            _vm._v(" "),
            _vm.isShowTips
              ? _c("div", { staticClass: "tips" }, [
                  _vm._v(
                    "领取成功，正在为你跳转高德打车（" +
                      _vm._s(_vm.dateCount) +
                      "）"
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.isShowGuide
            ? _c("div", { staticClass: "reward-mask" }, [
                _c("div", { staticClass: "arrow" }),
                _vm._v(" "),
                !_vm.isIos
                  ? _c("div", { staticClass: "guard android" })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isIos ? _c("div", { staticClass: "guard ios" }) : _vm._e()
              ])
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }